module.exports = __webpack_public_path__ + "static/media/tv-1.70d63662.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tv-1.jpg
// module id = 123
// module chunks = 0